/* eslint-disable import/no-anonymous-default-export*/
import {
  NOTIFICATION_SUCCESS,
  REDIRECT,
  GET_NOTIFICATION,
  GET_NOTIFICATIONS,
  POP_UP_OPEN,
  CHANGE_NOTIFICATION_READ_STATUS,
  NOTIFICATION_FAIL,
} from "../actions/types";

const initialState = {
  isLoading: true,
  isPopupOpen: false,
  newNotification: false,
  notifications: [],
  notification: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newNotification: true,
        notification: action.payload,
      };

    case NOTIFICATION_FAIL:
      return {
        ...state,
        newNotification: false,
      };
    case GET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };
    case POP_UP_OPEN:
      return {
        ...state,
        isPopupOpen: true,
        newNotification: false,
      };

    case CHANGE_NOTIFICATION_READ_STATUS:
      return {
        ...state,
        isRead: true,
      };
    case REDIRECT:
      return {
        ...state,
        isLoading: true,
        newNotification: true,
      };

    default:
      return state;
  }
}
